import { useMemo } from 'react'
import { inDateRange, sortByRelevance } from '@shared/ranking'
import { eventRegionId } from '@shared/regions'
import { byStartDateAsc } from '../../lib/utils'
import type { Event } from '../../types'
import type { ListSort } from './useListControls'

/**
 * The full list narrowed to the date bounds (inclusive; `end` null = open-ended) and put in the chosen order.
 * Relevance is the viewer's ranking (global score + followed artists + friends
 * going) with events from neighbouring regions discounted; `regionId` null =
 * everywhere.
 */
export function useSortedList(
  events: Event[],
  start: string,
  end: string | null,
  sort: ListSort,
  artistMatches: Map<string, number>,
  regionId: string | null,
  crewCounts: Map<string, number>,
): Event[] {
  return useMemo(() => {
    const inRange = events.filter(e => inDateRange(e, { start, end }))
    if (sort === 'date') return [...inRange].sort(byStartDateAsc)
    return sortByRelevance(inRange, artistMatches, e => !regionId || eventRegionId(e) === regionId, crewCounts)
  }, [events, start, end, sort, artistMatches, regionId, crewCounts])
}
